module.exports = __webpack_public_path__ + "img/item5.52087b0f.png";